/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';

import { LoginConfig } from "./login.config";
import { Subscription } from 'rxjs';
import { SignerService } from './signer.service';

@Injectable()
export class SignerResolver implements Resolve<any> {
  constructor(private signersvc: SignerService, private router: Router) { }
  resolve(route: ActivatedRouteSnapshot): Subscription {
    return this.signersvc.OnLoginCallback(route.queryParams).subscribe(
      response => {
        return Observable.of('Signing successful.');
      },
      error => {
        this.router.navigate([LoginConfig.getFormattedPath(this.signersvc.app_path, 'dashboard', true)]);
        return Observable.throw('Unable to Sign document.');
      }
    );
  }
}
